import {IntermediatePart} from "../../intermediatePart";

const widthAndHeightArray = ["Width", "Height"];

export default class Fridge extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'fridge';
    this.partName = 'Fridge';
    this.translateId = "visualizer.kitchen.appliance.fridge";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Fridge());
  }

  getFridgeWidthAndHeightConditions = () => {
    let widthHeightConditions = []
    if (!this.activeFeature || !this.activeFeature.metaData) {
      return widthHeightConditions
    }
    widthAndHeightArray.forEach(metaName => {
      if (this.activeFeature.metaData[metaName]) {
        widthHeightConditions.push({
          propName: metaName,
          propValue: Array.isArray(this.activeFeature.metaData[metaName])
            ? this.activeFeature.metaData[metaName][0]
            : this.activeFeature.metaData[metaName],
        })
      }
    });
    return widthHeightConditions
  }

  navigationSubItems(...props) {
    const [, , , , restOptions = {}] = props;
    const layout = this.getParent().layout;
    if (layout.type === 1) {
      restOptions.returnAllFeatures = true;
      const navItems = super.navigationSubItems(...props);
      return navItems.map(nItem => {
        nItem.notAvailableInVisualizer = true;
        nItem.part = nItem.part.clone();
        nItem.part.notAvailableInVisualizer = true;
        return nItem
      })
    }
    return super.navigationSubItems(...props);
  }

  clone() {
    return Object.assign(Object.create(Object.getPrototypeOf(this)), this);
  }

  // getArrayOfConditions() {
  //   const layout = this.getParent().layout;
  //   if (layout.type === 1) {
  //     return [{
  //       propName: 'RoomLayout',
  //       propValue: 'Layout2',
  //     }];
  //   }
  //   return super.getArrayOfConditions()
  // }
}
